"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const AddressWidget_module_scss_1 = __importDefault(require("./AddressWidget.module.scss"));
const react_hook_form_1 = require("react-hook-form");
const feed_factory_models_ndtrc_1 = require("@feed-factory/feed-factory.models.ndtrc");
const react_select_1 = __importDefault(require("react-select"));
const AddressWidget = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { register, control } = props.formMethods;
    return (react_1.default.createElement("div", { className: `${AddressWidget_module_scss_1.default.AddressWidget} ff-address-widget` },
        react_1.default.createElement("div", { className: AddressWidget_module_scss_1.default.streetWithHousenr },
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", null, t("address.street")),
                react_1.default.createElement("input", Object.assign({}, register(`${props.namespace}street`)))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("label", null, t("address.housenr")),
                react_1.default.createElement("input", Object.assign({}, register(`${props.namespace}housenr`))))),
        react_1.default.createElement("label", null, t("address.zipcode")),
        react_1.default.createElement("input", Object.assign({}, register(`${props.namespace}zipcode`))),
        react_1.default.createElement("label", null, t("address.city")),
        react_1.default.createElement("input", Object.assign({}, register(`${props.namespace}city`))),
        !props.hideCountryField && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("label", null, t("address.country")),
            react_1.default.createElement(react_hook_form_1.Controller, { name: `${props.namespace}country`, control: control, render: ({ field: { onChange, onBlur, value, name, ref }, fieldState: { invalid, isTouched, isDirty, error }, formState, }) => {
                    const currentSelection = feed_factory_models_ndtrc_1.CountryCodes.find((item) => item.value === value);
                    return (react_1.default.createElement(react_select_1.default, { className: AddressWidget_module_scss_1.default.singleDateStatusSelect, value: currentSelection, isClearable: true, options: feed_factory_models_ndtrc_1.CountryCodes, menuPlacement: "auto", placeholder: `${t("form.select")}...`, styles: {
                            menu: (provided, state) => {
                                return Object.assign(Object.assign({}, provided), { zIndex: 2 });
                            },
                        }, onChange: (item) => {
                            onChange(item === null || item === void 0 ? void 0 : item.value);
                        } }));
                } })))));
};
exports.default = AddressWidget;
//# sourceMappingURL=AddressWidget.js.map